import springboard from 'springboard';
import {isAudioFile} from '@/utils/file_utils';
import {DBObjects} from '@/store/store_types';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        GlobalKeyListener: GlobalKeyListenerModule;
    }
}

type GlobalKeyListenerModule = {
    setCurrentFileInfo: (fileInfo: DBObjects['File'] | null) => void;
};

springboard.registerModule('GlobalKeyListener', {}, async (moduleAPI): Promise<GlobalKeyListenerModule> => {
    let holdingSpace = false;
    let currentFileInfo: DBObjects['File'] | null = null;

    const setCurrentFileInfo = (fileInfo: DBObjects['File'] | null) => {
        currentFileInfo = fileInfo;
    };

    window.addEventListener('keyup', (event: KeyboardEvent) => {
        if (event.code === 'Space') {
            holdingSpace = false;
        }
    });

    window.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.code === 'Space' && 
            event.target instanceof HTMLElement && 
            !['INPUT', 'TEXTAREA'].includes(event.target.tagName) &&
            !event.target.isContentEditable) {
            
            if (holdingSpace) {
                return;
            }

            const audioPlayerModule = moduleAPI.getModule('AudioPlayer');
            const currentlyPlayingFile = audioPlayerModule.currentlyPlayingFile.getState();
            
            // If there's already audio playing, try to toggle play/pause
            if (currentlyPlayingFile) {
                if ((window as any).togglePlayPause) {
                    event.preventDefault();
                    (window as any).togglePlayPause();
                    holdingSpace = true;
                }
                return;
            }

            // If no audio is playing and we're on a file view page, try to play the current file
            if (currentFileInfo) {
                if (isAudioFile(currentFileInfo.name)) {
                    event.preventDefault();
                    audioPlayerModule.playFile(currentFileInfo);
                    holdingSpace = true;
                }
            }
        }
    });

    return {
        setCurrentFileInfo,
    };
});